/* UCH 2026-11-03: 最近下单弹窗 + 商品页常驻小字（11/3 晚 v3）。
   UCH 和 Livara 两家店共用这份代码（Livara 上文件名是 livara-sales-pop.js）。数据来自各自店铺的 metafield
   uch.recent_sales / livara.recent_sales（Railway 项目 uch-sales-pop 每 5 分钟同步，见 ~/Documents/UCH/sales-pop-20261103），
   snippet 把它放进 #uch-sales-pop-data。全部是真实数字：
   - 订单：7 天内真实已付款的网站单，只显示 区名, 州 + 商品 + 多久前（按访客当前时间算），不显示名字；商品页先弹这款自己的单。
   - 汇总：每 3 条订单插一条「N people ordered … in the last 7 days」（≥5 单才显示）/ 全站 7 天订单数（≥20）/
     浏览：今天商品页落地访问 ≥50 用今天，不够用 30 天（≥300）/ 全站加购：今天 ≥10 用今天，不够用 30 天 /
     自建加购计数：这款被加进了 N 个购物车（≥10）。「今天」的数要和悉尼当天日期对得上才显示，过期的不显示。
   - 商品页价格下面常驻：「🔥 N sold · N views in the last 30 days」（已售 ≥10 件、浏览 ≥300 才各自显示），
     第二行「🛒 Added to N carts since 3 Nov / in the last 30 days」（≥10 才显示，计数 11/3 才开始，没满 30 天写开始日期）。
     浏览 ≥1000 时往下取整到百位加「+」（落地访问只会比实际浏览少）。
   节奏（11/3 23:40 店主要求不停）：进站 2 秒弹第一条，每条 6 秒（鼠标停着不消失），消失后 1.5 秒弹下一条（店主 11/3 定），不设上限。
   每笔订单一次访问只弹一次（不循环订单）；订单弹完后只循环汇总数字（统计数，重复显示不会让人以为是新订单）。点 × 这次访问不再弹。
   购物车抽屉打开时隐藏，粘性加购条出现时抬到条上方（CSS）。 */
(function () {
  'use strict';

  var PREVIEW_ONLY = false;   // true = 只在带 ?uchpop=1 的访问里弹（上线前自测用）
  var MAX_AGE_MS = 7 * 24 * 3600 * 1000;
  var FIRST_DELAY = 2000, SHOW_MS = 6000, GAP_MS = 1500, ROUNDUP_EVERY = 3;
  var MIN_O7 = 5, MIN_SITE7 = 20, MIN_U30 = 10, MIN_VIEWS = 50, MIN_VIEWS30 = 300, MIN_ATC = 10, MIN_CARTS = 10;   // 门槛和 sync.py 一致，数字太小就不显示
  var KEY = 'uchSalesPop';

  function load() {
    try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  }
  function save(s) {
    try { sessionStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
  }
  function sydneyToday() {
    try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'Australia/Sydney' }).format(new Date()); } catch (e) { return ''; }
  }
  function ago(ms) {
    var m = Math.floor(ms / 60000);
    if (m < 2) return 'Just now';
    if (m < 60) return m + ' minutes ago';
    var h = Math.floor(m / 60);
    if (h < 24) return h === 1 ? '1 hour ago' : h + ' hours ago';
    var d = Math.floor(h / 24);
    return d === 1 ? '1 day ago' : d + ' days ago';
  }
  function fmt(n) { return Number(n).toLocaleString('en-AU'); }
  function fmtViews(n) { return n >= 1000 ? fmt(Math.floor(n / 100) * 100) + '+' : fmt(n); }   // 往下取整，只会少说
  function fmtDay(iso) {
    var p = (iso || '').split('-');
    return p.length === 3 ? +p[2] + ' ' + ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][+p[1] - 1] : '';
  }
  function cartsWindow(stats) { return stats.carts_since ? 'since ' + fmtDay(stats.carts_since) : 'in the last 30 days'; }

  function statLines(stats, handle) {
    if (document.querySelector('.uch-sold')) return;
    var anchor = document.querySelector('product-info .uebc__hero') ||          // UCH：黑五价格块后面
      document.querySelector('product-info .product__block--price') ||           // Livara（Hyper 主题）：价格块后面、倒计时前面
      document.querySelector('product-info[id^="MainProduct-"] [id^="price-"]');
    if (!anchor) return;
    var p = stats.prod && stats.prod[handle];
    var v30 = stats.views30 && stats.views30[handle];
    var c = stats.carts && stats.carts[handle];
    var parts = [];
    if (p && p.u30 >= MIN_U30) parts.push(fmt(p.u30) + ' sold');
    if (v30 >= MIN_VIEWS30) parts.push(fmtViews(v30) + ' views');
    var lines = [];
    if (parts.length) lines.push('\uD83D\uDD25 ' + parts.join(' \u00B7 ') + ' in the last 30 days');
    if (c >= MIN_CARTS) lines.push('\uD83D\uDED2 Added to ' + fmt(c) + ' carts ' + cartsWindow(stats));
    var after = anchor;
    lines.forEach(function (t) {
      var el = document.createElement('p');
      el.className = 'uch-sold';
      el.textContent = t;
      after.parentNode.insertBefore(el, after.nextSibling);
      after = el;
    });
  }

  function init() {
    var el = document.getElementById('uch-sales-pop-data');
    if (!el) return;
    var data;
    try { data = JSON.parse(el.textContent); } catch (e) { return; }
    var stats = data.stats || {};
    var todayOk = !!stats.day && stats.day === sydneyToday();
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    var handle = m ? decodeURIComponent(m[1]) : '';

    if (handle) statLines(stats, handle);

    if (PREVIEW_ONLY) {
      if (/[?&]uchpop=1/.test(location.search)) { try { sessionStorage.setItem(KEY + 'Preview', '1'); } catch (e) {} }
      var preview = false;
      try { preview = sessionStorage.getItem(KEY + 'Preview') === '1'; } catch (e) {}
      if (!preview) return;
    }

    var state = load();
    state.seen = state.seen || [];
    if (state.off) return;

    var now = Date.now();
    var orders = (data.items || []).filter(function (it) {
      var t = Date.parse(it.t);
      return it.k && t && now - t >= 0 && now - t <= MAX_AGE_MS && state.seen.indexOf(it.k) === -1;
    }).sort(function (a, b) {
      var pa = a.h === handle ? 1 : 0, pb = b.h === handle ? 1 : 0;   // 商品页先弹这款自己的单
      return pb - pa || Date.parse(b.t) - Date.parse(a.t);
    }).map(function (it) {
      return { k: it.k, t: Date.parse(it.t), href: '/products/' + it.h, img: it.img,
        who: 'Someone in ' + it.c + (it.s ? ', ' + it.s : ''), pre: 'purchased ', strong: it.p, post: '', ok: 'Verified order' };
    });

    var roundups = [];
    var prods = stats.prod || {};
    var hot = Object.keys(prods).filter(function (h) { return prods[h].o7 >= MIN_O7; })
      .sort(function (a, b) { return (b === handle) - (a === handle) || prods[b].o7 - prods[a].o7; });
    hot.forEach(function (h) {
      var p = prods[h];
      roundups.push(h === handle
        ? { k: 'r7:' + h, img: p.img, who: fmt(p.o7) + ' people ordered this', pre: 'in the last 7 days', strong: '', post: '', ok: 'Verified orders' }
        : { k: 'r7:' + h, href: '/products/' + h, img: p.img, who: fmt(p.o7) + ' people ordered in the last 7 days', pre: '', strong: p.p, post: '', ok: 'Verified orders' });
    });
    // 浏览：今天够 50 用今天，不够用 30 天；最多两款（当前商品优先）
    var v30all = stats.views30 || {};
    function rank30(h) { return Object.keys(v30all).filter(function (x) { return v30all[x] > v30all[h]; }).length + 1; }
    var views = {};
    Object.keys(prods).concat(Object.keys(stats.views30 || {})).forEach(function (h) {
      if (!prods[h] || views[h]) return;
      var t = todayOk && stats.views && stats.views[h], m30 = stats.views30 && stats.views30[h];
      if (t >= MIN_VIEWS) views[h] = { k: 'v:' + stats.day + ':' + h, n: t, who: 'Viewed ' + fmt(t) + ' times today', pre: 'Popular today' };
      else if (m30 >= MIN_VIEWS30) views[h] = { k: 'v30:' + h, n: m30, who: 'Viewed ' + fmtViews(m30) + ' times in the last 30 days',
        pre: rank30(h) <= 3 ? 'One of our most viewed' : '' };   // 「浏览最多之一」只给 30 天浏览排前三的
    });
    Object.keys(views).sort(function (a, b) { return (b === handle) - (a === handle) || views[b].n - views[a].n; })
      .slice(0, 2).forEach(function (h) {
        var x = views[h];
        roundups.push(h === handle
          ? { k: x.k, img: prods[h].img, who: x.who, pre: x.pre, strong: '', post: '', ok: '' }
          : { k: x.k, href: '/products/' + h, img: prods[h].img, who: x.who, pre: '', strong: prods[h].p, post: '', ok: '' });
      });
    // 自建加购计数：这款被加进了几个购物车（当前商品优先，最多两款）
    Object.keys(stats.carts || {}).filter(function (h) { return prods[h] && stats.carts[h] >= MIN_CARTS; })
      .sort(function (a, b) { return (b === handle) - (a === handle) || stats.carts[b] - stats.carts[a]; })
      .slice(0, 2).forEach(function (h) {
        var who = 'Added to ' + fmt(stats.carts[h]) + ' carts ' + cartsWindow(stats);
        roundups.push(h === handle
          ? { k: 'c:' + h, img: prods[h].img, who: who, pre: 'Shoppers are adding this to their carts', strong: '', post: '', ok: '' }
          : { k: 'c:' + h, href: '/products/' + h, img: prods[h].img, who: who, pre: '', strong: prods[h].p, post: '', ok: '' });
      });
    // 全站加购：今天够 10 用今天，不够用 30 天
    if (todayOk && stats.atc >= MIN_ATC) {
      roundups.push({ k: 'atc:' + stats.day, who: fmt(stats.atc) + ' items added to carts today', pre: 'across our store', strong: '', post: '', ok: '' });
    } else if (stats.atc30 >= MIN_ATC) {
      roundups.push({ k: 'atc30', who: fmt(stats.atc30) + ' items added to carts', pre: 'in the last 30 days', strong: '', post: '', ok: '' });
    }
    if (stats.site7 >= MIN_SITE7) {
      roundups.push({ k: 'site7', who: fmt(stats.site7) + ' orders across Australia', pre: 'in the last 7 days', strong: '', post: '', ok: 'Verified orders' });
    }
    var allRoundups = roundups.slice();   // 订单弹完后循环这些统计数
    roundups = roundups.filter(function (r) { return state.seen.indexOf(r.k) === -1; });

    // 订单为主，每 ROUNDUP_EVERY 条订单后插一条汇总；订单用完了就接着放汇总
    var queue = [], oi = 0, ri = 0;
    while (oi < orders.length || ri < roundups.length) {
      for (var j = 0; j < ROUNDUP_EVERY && oi < orders.length; j++) queue.push(orders[oi++]);
      if (ri < roundups.length) queue.push(roundups[ri++]);
    }
    if (!queue.length) queue = allRoundups.slice();
    if (!queue.length) return;

    var box = document.createElement('div');
    box.className = 'uch-pop';
    box.setAttribute('role', 'status');
    box.setAttribute('aria-live', 'polite');
    box.innerHTML =
      '<a class="uch-pop__link">' +
        '<img class="uch-pop__img" alt="" width="64" height="64" loading="lazy">' +
        '<span class="uch-pop__body">' +
          '<span class="uch-pop__who"></span>' +
          '<span class="uch-pop__what"><span class="uch-pop__pre"></span><strong></strong><span class="uch-pop__post"></span></span>' +
          '<span class="uch-pop__when"><span class="uch-pop__time"></span><span class="uch-pop__ok"></span></span>' +
        '</span>' +
      '</a>' +
      '<button type="button" class="uch-pop__x" aria-label="Close">&times;</button>';
    document.body.appendChild(box);

    var link = box.querySelector('.uch-pop__link');
    var img = box.querySelector('.uch-pop__img');
    var q = function (s) { return box.querySelector(s); };
    var hideTimer = null, nextTimer = null, hovering = false;

    function hide() { box.classList.remove('uch-pop--in'); }
    function scheduleNext(delay) {
      window.clearTimeout(nextTimer);
      if (state.off) return;
      if (!queue.length) queue = allRoundups.slice();   // 订单都弹过了：只循环统计数
      if (!queue.length) return;
      nextTimer = window.setTimeout(show, delay);
    }
    function show() {
      if (document.hidden) { scheduleNext(3000); return; }
      var it = queue.shift();
      if (!it) return;
      if (it.t && Date.now() - it.t > MAX_AGE_MS) { scheduleNext(0); return; }
      if (it.href) { link.setAttribute('href', it.href); } else { link.removeAttribute('href'); }
      if (it.img) { img.src = it.img; img.hidden = false; } else { img.removeAttribute('src'); img.hidden = true; }
      q('.uch-pop__who').textContent = it.who;
      q('.uch-pop__pre').textContent = it.pre;
      q('.uch-pop__what strong').textContent = it.strong;
      q('.uch-pop__post').textContent = it.post;
      q('.uch-pop__time').textContent = it.t ? ago(Date.now() - it.t) : '';
      q('.uch-pop__ok').textContent = it.ok;
      q('.uch-pop__ok').hidden = !it.ok;
      box.classList.toggle('uch-pop--stat', !it.t);
      box.classList.add('uch-pop--in');
      if (state.seen.indexOf(it.k) === -1) { state.seen.push(it.k); save(state); }
      if (window.clarity) { try { window.clarity('event', it.t ? 'sales_pop_shown' : 'sales_pop_stat_shown'); } catch (e) {} }
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(function wait() {
        if (hovering) { hideTimer = window.setTimeout(wait, 1000); return; }
        hide();
        scheduleNext(GAP_MS);
      }, SHOW_MS);
    }

    box.addEventListener('mouseenter', function () { hovering = true; });
    box.addEventListener('mouseleave', function () { hovering = false; });
    link.addEventListener('click', function () {
      if (link.hasAttribute('href') && window.clarity) { try { window.clarity('event', 'sales_pop_click'); } catch (e) {} }
    });
    q('.uch-pop__x').addEventListener('click', function () {
      state.off = true;
      save(state);
      window.clearTimeout(nextTimer);
      window.clearTimeout(hideTimer);
      hide();
    });

    scheduleNext(FIRST_DELAY);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
